import { defaultTranslation } from './defaultTranslation';

function areTranslationsCorrupted(messages) {
  return messages && Object.values(messages.translations)
    .some(translation => translation?.includes(String.fromCodePoint(65533)));
}

function areValidTranslations(translations, userUuid, lang) {
  const lastReloadUiTimestamp = typeof TRANSLATIONS_RELOADED_UI === 'undefined'
    ? 0
    : Number.parseInt(TRANSLATIONS_RELOADED_UI, 10);
  return translations
    && translations.translations
    && translations.userUuid === userUuid
    && translations.lang === lang
    && 'timestamp' in translations
    && translations.timestamp > lastReloadUiTimestamp
    // testcafe (ui tests) sometimes corrupt the translations
    && !areTranslationsCorrupted(translations);
}

function refreshClientsideTranslations() {
  const userUuid = USER_UUID;
  const savedTranslations = JSON.parse(localStorage.getItem('messages'));

  window.initLocale = { translations: { ...defaultTranslation[lang] } };
  if (areValidTranslations(savedTranslations, userUuid, lang)) {
    window.initLocale = {
      ...savedTranslations,
      translations: {
        ...defaultTranslation[lang],
        ...savedTranslations.translations,
      },
    };
  } else {
    const _i18n_data_xhr = new XMLHttpRequest();
    // url can show to translation microservce or to endpoint of wb-web
    _i18n_data_xhr.open('GET', `${LOAD_TRANSLATIONS_ENDPOINT}?system=web&translation_type=text&lang=${lang}`, false);
    _i18n_data_xhr.setRequestHeader('Accept', 'application/json');
    if (typeof JWT_TOKEN === 'string' && JWT_TOKEN) {
      _i18n_data_xhr.setRequestHeader('Authorization', `Bearer ${JWT_TOKEN}`);
    }

    _i18n_data_xhr.addEventListener('load', function() {
      if (_i18n_data_xhr.readyState === 4) {
        if (_i18n_data_xhr.status === 200) {
          const translations = JSON.parse(this.responseText);
          const messages = {
            translations: {
              ...defaultTranslation[lang],
              ...translations[lang],
            },
            timestamp: Date.now(),
            userUuid,
            lang,
          };
          window.initLocale = messages;
          // CAUTION: this localStorage field is used by wb-ui as well.
          localStorage.setItem('messages', JSON.stringify(messages));
        } else {
          console.error(_i18n_data_xhr.statusText);
        }
      }
    });

    // eslint-disable-next-line unicorn/prefer-add-event-listener
    _i18n_data_xhr.onerror = function() {
      console.error(_i18n_data_xhr.statusText);
    };

    _i18n_data_xhr.send(null);
  }
}

refreshClientsideTranslations();
